import { Injectable, OnDestroy } from '@angular/core';
import CryptoJS from 'crypto-js';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LocalStorageKeys } from '../../LocalStorageKeys';
import { SessionStorageKeys } from '../../SessionStorageKeys';
import { LocalStorageService } from '../local-storage/local-storage.service';

@Injectable()
export class SessionService implements OnDestroy {
  public accountId;
  public email;
  private session$ = new BehaviorSubject({
    accountId: undefined,
    email: undefined,
  });
  private destroy$ = new Subject<void>();

  get sessionSub() {
    return this.session$;
  }

  get destroySub() {
    return this.destroy$;
  }

  constructor(private localStorage: LocalStorageService) {
    this.session$
      .asObservable()
      .pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        this.accountId = result.accountId;
        this.email = result.email;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getSessionID(): string {
    return sessionStorage.getItem(SessionStorageKeys.SESSIONID)?.replace(/-/g, '');
  }

  setSessionID(newAccessToken: string): void {
    const hash = CryptoJS.SHA256(newAccessToken).toString(CryptoJS.enc.Base64).toLowerCase().replace(/[+/-]/g, '');
    sessionStorage.setItem(SessionStorageKeys.SESSIONID, hash);
  }

  getUID(): string {
    if (this.localStorage.getItem(LocalStorageKeys.SELECTED_PROFILE_ID)) {
      return this.localStorage.getItem(LocalStorageKeys.SELECTED_PROFILE_ID);
    }
    return undefined;
  }
}
